import { createSelector } from "reselect";
import _ from "lodash";
export const createSelectors = parentReducer => {
    return new (class {
        getRequesting = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["AlertsWidgetQualificationAlerts_reducer"];
            return reducer.requesting;
        };
        selectQualification = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["AlertsWidgetQualificationAlerts_reducer"];
            return reducer.qualificationAlerts;
        };
        selectQualificationAlerts = createSelector([this.selectQualification], (qualificationAlerts = false) => {
            if(qualificationAlerts){
                return _.sortBy(qualificationAlerts,o => o[0].days)
            }
        })
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["AlertsWidgetQualificationAlerts_reducer"];
            return reducer.users;
        };
        selectUserInfo = createSelector([this.selectUsers], (users = false) => {
            if (users) {
                let userInfo = Object.keys(users).map(e => {
                    let uid = e;
                    let fname = _.get(users[e], "profile.first_name") || "N/A";
                    let lname = _.get(users[e], "profile.last_name") || "N/A";
                    return { uid, name: `${fname} ${lname}` };
                });
                return userInfo;
            } else {
                return false;
            }
        });
    })();
};
export default createSelectors;
